"use client";
import { Alert, Snackbar } from "@mui/material";
import type React from "react";

interface SnackbarNotificationProps {
	open: boolean;
	onClose: () => void;
	message: string;
	severity: "success" | "error" | "warning" | "info";
	autoHideDuration?: number;
}

export function SnackbarNotification({
	open,
	onClose,
	message,
	severity,
	autoHideDuration = 6000,
}: SnackbarNotificationProps): React.ReactElement {
	return (
		<Snackbar open={open} autoHideDuration={autoHideDuration} onClose={onClose}>
			<Alert onClose={onClose} severity={severity}>
				{message}
			</Alert>
		</Snackbar>
	);
}
